import { useLocale } from '@/i18n/LocaleProvider';
import { Icon } from './Icon';

/** TH/EN language toggle pill. */
export function LangToggle() {
  const { locale, toggle } = useLocale();
  return (
    <button
      onClick={toggle}
      title="Switch language"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        border: '1px solid var(--line-2)',
        background: 'var(--card)',
        borderRadius: 99,
        padding: '6px 12px',
        cursor: 'pointer',
        fontFamily: 'var(--font)',
        fontSize: 12,
        fontWeight: 500,
        color: 'var(--ink-2)',
        letterSpacing: '.04em',
      }}
    >
      <Icon name="globe" size={14} />
      {locale === 'en' ? 'ไทย' : 'ENG'}
    </button>
  );
}
